import { Injectable, PLATFORM_ID, NgZone } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from '@angular/fire/database';
import { Telemetry } from '../models/telemetry';
import { Observable } from 'rxjs';
import { FirebaseAppConfig } from '@angular/fire';


@Injectable({
  providedIn: 'root'
})
export class TelemetryService {
  private _afb: AngularFireDatabase;
  array: any[] = [];

  constructor(private zone: NgZone) {}

  public UpdateProyect(config: FirebaseAppConfig, firebaseAppName: string){
    this._afb = new AngularFireDatabase(config, firebaseAppName, config['databaseURL'], PLATFORM_ID, this.zone)
  }

  getTelemetry(id: string){
    return this._afb.object('dev_telemetry/'+id).valueChanges();    
  }

  


}
